import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { APIService, KPI } from '../api';
import { ScopeService } from './scope.service';

@Injectable()
export class InvestmentStatusesService {

  constructor(
    private api: APIService,
    private scope: ScopeService,
  ) { }


  /**
   * Calls the api to update an investment status
   *
   * @param idStatus
   * @param status
   */
  public updateInvestmentStatus(
    idStatus: number, status: Partial<KPI.InvestmentStatus>,
  ): Observable<KPI.InvestmentStatus> {
    return this.api.investments_investment_statuses_patch(idStatus, status).pipe(
      tap(() => this.scope.refreshInvestmentStatuses()),
    );
  }

  /**
   * Calls the api to create an investment status
   *
   * @param status
   */
  public createInvestmentStatus(status: Partial<KPI.InvestmentStatus>): Observable<KPI.InvestmentStatus> {
    return this.api.investments_investment_statuses_post(status).pipe(
      tap(() => this.scope.refreshInvestmentStatuses()),
    );
  }

  /** @returns Allowed status transitions */
  public getAllowedTransitionsStatus(): Observable<KPI.AllowedStatusTransition[]> {
    return this.api.user_investments_status_transition();
  }

  public get investmentStatusTransitions$(): Observable<KPI.InvestmentStatusTransition[]> {
    return this.api.investment_status_tansitions();
  }

  public updateMultipleInvestmentsStatus(investmentsIds: number[], current_status: number, new_status: number) {
    return this.api.investments_status_change(investmentsIds, current_status, new_status);
  }
}
